import { useState, useEffect } from 'react'

interface Options {
  readonly updateOnResize?: boolean
  readonly updateOnOrientationChange?: boolean
}

const defaultOptions = {
  updateOnResize: true,
  updateOnOrientationChange: true,
}

const useViewport = (options: Options = defaultOptions) => {
  const [vw, setVW] = useState(0)
  const [vh, setVH] = useState(0)

  const { updateOnResize, updateOnOrientationChange } = options

  useEffect(() => {
    const setSizes = () => {
      if (window.innerWidth !== vw) {
        setVW(window.innerWidth * 0.01)
      }

      if (window.innerHeight !== vh) {
        setVH(window.innerHeight * 0.01)
      }
    }

    setSizes()

    if (updateOnResize) {
      window.addEventListener('resize', setSizes)

      return () => window.removeEventListener('resize', setSizes)
    }

    if (updateOnOrientationChange) {
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          setSizes()

          return () => window.removeEventListener('orientationchange', setSizes)
        }, 100)
      })
    }
  }, [updateOnResize, vh, vw])

  return { vw, vh }
}

export default useViewport
